import { render, staticRenderFns } from "./CronReportCard.vue?vue&type=template&id=bb11c964&scoped=true"
import script from "./CronReportCard.vue?vue&type=script&lang=js"
export * from "./CronReportCard.vue?vue&type=script&lang=js"
import style0 from "./CronReportCard.vue?vue&type=style&index=0&id=bb11c964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb11c964",
  null
  
)

export default component.exports